type HeaderNavLinkTone = "light" | "dark";

/**
 * Top-level navigation stays visually quiet until the user interacts with it.
 * The links keep an accessible touch target, while colour and a soft surface
 * replace the previous permanent outline, shadow, and lift treatment.
 */
const baseClasses =
  "inline-flex min-h-10 items-center justify-center whitespace-nowrap rounded-xl px-2.5 py-2 text-sm font-semibold transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:min-h-11 md:px-3.5 md:text-base lg:px-4 xl:px-5";

export function headerNavLinkClass({
  tone,
  isOpen = false,
}: {
  tone: HeaderNavLinkTone;
  isOpen?: boolean;
}): string {
  const toneClasses =
    tone === "dark"
      ? isOpen
        ? " bg-white/20 text-white focus-visible:ring-white/70 focus-visible:ring-offset-blue-600"
        : " bg-transparent text-white/95 hover:bg-white/15 hover:text-white focus-visible:ring-white/70 focus-visible:ring-offset-blue-600"
      : isOpen
      ? " bg-blue-100 text-blue-800 focus-visible:ring-blue-500/50 focus-visible:ring-offset-white"
      : " bg-transparent text-blue-700 hover:bg-blue-50 hover:text-blue-800 focus-visible:ring-blue-500/50 focus-visible:ring-offset-white";

  return `${baseClasses}${toneClasses}`;
}
